import React from 'react';
import { textTransformer } from '../../utils';
import { TableComponentsProps } from '../table-components.props';
import {DataQualityLabels , DataQualityLabel} from '../../my-vehicles.props';
import classes from './data-quality.module.scss';

export const DataQuality = ({ row }: TableComponentsProps): JSX.Element=> {
  const label = row && row.uds_date_quality_statecode?.label;

  const getAppropriateColor = (expression:DataQualityLabels | undefined):string=>{
     switch(expression){
        case DataQualityLabel.Good:
            return classes.good_quality;
        case DataQualityLabel.Average:
            return classes.averege_quality;
        case DataQualityLabel.Bad:
            return classes.bad_quality;
        default:
            return '';
     }
  }

  return (
    <span className={getAppropriateColor(label)}>
      {label ? textTransformer(' ', 'end', 1, true, label) : '-'}
    </span>
  );
};
